<p-blockUI [blocked]="pageLoading()" />
<app-progress-spinner [enabled]="pageLoading()" />

<header>
  <p-panel [showHeader]="true" header="Filters" [toggleable]="true">
    <form [formGroup]="searchForm">
      <div class="filter-input">
        <label for="startDate">{{ 'CRM.LABEL.START_DATE' | translate }}:</label>
        <p-datepicker
          formControlName="startDate"
          dateFormat="yy-mm-dd"
          appendTo="body"
        />
      </div>
      <div class="filter-input">
        <label for="endDate">{{ 'CRM.LABEL.END_DATE' | translate }}:</label>
        <p-datepicker
          formControlName="endDate"
          dateFormat="yy-mm-dd"
          appendTo="body"
        />
      </div>
      <div class="filter-input">
        <label for="aor">{{ 'CRM.LABEL.AOR' | translate }}:</label>
        <p-select
          formControlName="aor"
          [options]="aors()"
          optionLabel="name"
          optionValue="name"
          [showClear]="true"
        />
      </div>
      <div class="filter-input">
        <label for="category">{{ 'CRM.LABEL.CATEGORY' | translate }}:</label>
        <p-select
          formControlName="category"
          [options]="categories()"
          [showClear]="true"
        />
      </div>
      <div class="filter-input">
        <label for="noteType">{{ 'CRM.LABEL.NOTE_TYPE' | translate }}:</label>
        <p-select
          formControlName="noteType"
          [options]="noteTypes()"
          optionLabel="name"
          optionValue="name"
          [showClear]="true"
        />
      </div>
      <div class="filter-input">
        <label for="facilityName"
          >{{ 'LOCATION.LABEL.FACILITY_NAME' | translate }}:</label
        >
        <input type="text" pInputText formControlName="facilityName" />
      </div>
      <div class="filter-input">
        <label for="noteText">{{ 'CRM.LABEL.NOTES' | translate }}:</label>
        <input type="text" pInputText formControlName="noteText" />
      </div>

      <div class="buttons">
        <button
          type="button"
          pButton
          class="nav-button filter-panel-button"
          (click)="retrieveControllerNotes()"
        >
          <i class="fa fa-search" pButtonIcon></i>
          <span pButtonLabel>{{
            'COMMON.LABEL.BUTTONS.RETRIEVE' | translate
          }}</span>
        </button>
        <button
          type="button"
          pButton
          class="nav-button filter-panel-button"
          (click)="clearFilters()"
        >
          <i class="fa fa-fw fa-eraser" pButtonIcon></i>
          <span pButtonLabel>{{
            'COMMON.LABEL.BUTTONS.CLEAR' | translate
          }}</span>
        </button>
      </div>
    </form>
  </p-panel>
</header>

<main>
  @if (controllerNotes().length > 0) {
    <p-paginator
      [showFirstLastIcon]="true"
      [showCurrentPageReport]="true"
      [rows]="pageSize()"
      (onPageChange)="onPageChange($event)"
      [totalRecords]="_totalRecords()"
      [first]="page() * pageSize()"
      currentPageReportTemplate="Showing {first}-{last} of {totalRecords}"
    />
  }
  @for (controllerNote of controllerNotes(); track controllerNote.id) {
    <p-card (click)="onControllerNoteSelected(controllerNote)">
      <ng-template #title>
        <div class="note-title">
          <span
            >{{ controllerNote.updatedAt | date: 'short' }} -
            {{ controllerNote.AORName }} -
            {{ controllerNote.facilityOrPipelineNum }}</span
          >
          <i class="fa fa-info-circle"></i>
        </div>
      </ng-template>
      <ng-template #subtitle
        >{{ controllerNote.category }} -
        {{ controllerNote.noteType }}</ng-template
      >
      <div class="card-section">
        {{ controllerNote.firstEntry }}
      </div>
    </p-card>
  } @empty {
    <p class="empty-results">No Results to display.</p>
  }
  @if (controllerNotes().length > 0) {
    <p-paginator
      [showFirstLastIcon]="true"
      [showCurrentPageReport]="true"
      [rows]="pageSize()"
      (onPageChange)="onPageChange($event)"
      [totalRecords]="_totalRecords()"
      [first]="page() * pageSize()"
      currentPageReportTemplate="Showing {first}-{last} of {totalRecords}"
    />
  }
</main>
